<script>
    import { api_host, user_store } from "../../stores.js";
    import { init_data } from '../../init.js';
    import { onMount } from 'svelte';
    import Header from "../header.svelte";
    import IFTAInput from "../../utils/iftainput.svelte";
    import { state_codes } from '../../globals.js';
    import { toast_message } from "../../utils/toast_message.js";
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { push, querystring } from 'svelte-spa-router';
    import { get_possible_roles } from '../../utils/format.js';


    let myself = {};
    let is_busy = false;
    let content_title = "Create User";
    let default_user_type = undefined;
    let adding_email = false, temp_email = '';
    let emails = [];

    const add_email = () => {
        temp_email = temp_email.trim().toLowerCase();
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!temp_email) 
            toast_message(false, 'Please enter email', 2000);
        else if (!temp_email.match(mailformat)) {
            toast_message(false, 'Please type valid email', 2000);
        } else {
            emails = [
                ...emails,
                temp_email
            ];
            temp_email = '';
            adding_email = false;
        }
    };

    const remove_email = async (index) => {
        const result = await Swal.fire({
            title: "Are you sure you want to delete this email?",
            text: '',
            buttonsStyling: true,
            confirmButtonClass: "button",
            confirmButtonText: 'Ok',
            cancelButtonText: "Cancel",
            showCancelButton: true,
            icon: "warning"
        });
        if (!result.isConfirmed) return;

        emails.splice(index, 1);
        emails = emails;
    };

    user_store.subscribe(value => {
        myself = value;
    });
    
    let fields = [
        {
            "index": 0,
            "group": "basic1",
            "type": "text",
            "label": "First Name",
            "value": "",
            "placeholder": "eg. Bart",
            "name": "user[first_name]",
            "error_text": "First Name is required",
            "validation_function": () => {
                if (fields[0].value.length) {
                    fields[0]['show_error'] = false;
                    return true;
                } else {
                    fields[0]['show_error'] = true;
                    return false;
                }
            }
        }, {
            "index": 1,
            "group": "basic1",
            "type": "text",
            "label": "Last Name",
            "value": "",
            "placeholder": "eg. Simpson",
            "name": "user[last_name]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[1]['show_error'] = false; return true; }
                if (fields[1].value.length) {
                    fields[1]['show_error'] = false;
                    return true;
                } else {
                    fields[1]['show_error'] = true;
                    fields[1]['error_text'] = 'Last Name is required';
                    return false;
                }
            }
        }, {
            "index": 2,
            "group": "basic2",
            "type": "text",
            "label": "Email",
            "value": "",
            "placeholder": "eg. bsimpson@mailinator.com",
            "name": "user[email]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor' && fields[2].value.length === 0) {
                    fields[2]['show_error'] = false;
                    return true;
                }
                const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                if (fields[2].value.match(mailformat)) {
                    fields[2]['show_error'] = false;
                    return true;
                } else {
                    fields[2]['show_error'] = true;
                    fields[2]['error_text'] = 'Invalid email';
                    return false;
                }
            }
        }, {
            "index": 3,
            "group": "basic2",
            "type": "select",
            "label": "Type of User",
            "value": "Employee",
            "select_options": get_possible_roles(myself.role, myself.plan_type),
            "name": "user[role]",
            "change_function": (evt) => {
                if (evt.target.value === 'Vendor') {
                    fields[0].label = "Name";
                    fields[0].error_text = "Name is required";
                    fields[1].hidden = true;
                } else {
                    fields[0].label = "First Name";
                    fields[0].error_text = "First Name is required";
                    fields[1].hidden = false;
                }
                if (evt.target.value === 'Employee' || evt.target.value === 'Contractor') {
                    fields[27].hidden = false;
                } else {
                    fields[27].hidden = true;
                }
                if (evt.target.value === 'Client') {
                    fields[28].hidden = false;
                    fields[29].hidden = false;
                } else {
                    fields[28].hidden = true;
                    fields[29].hidden = true;
                }
            },
            "validation_function": () => { return true; }
        }, {
            "index": 4,
            "group": "contractor",
            "type": "select",
            "label": "Business Structure",
            "value": "N/A",
            "select_options": ["N/A", "Sole Proprietorship", "LLC", "Other"],
            "name": "user[business_structure]",
            "validation_function": () => { return true; }
        }, {
            "index": 5,
            "group": "address",
            "type": "text",
            "label": "Street",
            "value": "",
            "placeholder": "eg. 123 My street",
            "name": "user[street]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[5]['show_error'] = false; return true; }
                if (fields[5].value.length) {
                    fields[5]['show_error'] = false;
                    return true;
                } else {
                    fields[5]['show_error'] = true;
                    fields[5]['error_text'] = 'Street is required';
                    return false;
                }
            }
        }, {
            "index": 6,
            "group": "address",
            "type": "text",
            "label": "City",
            "value": "",
            "placeholder": "eg. Springfield",
            "name": "user[city]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[6]['show_error'] = false; return true; }
                if (fields[6].value.length) {
                    fields[6]['show_error'] = false;
                    return true;
                } else {
                    fields[6]['show_error'] = true;
                    fields[6]['error_text'] = 'City is required';
                    return false;
                }
            }
        }, {
            "index": 7,
            "group": "address",
            "type": "select",
            "label": "State",
            "value": "Arizona",
            "select_options": Object.keys(state_codes),
            "name": "user[state]",
            "validation_function": () => {
                if (fields[3].value === 'Vendor') { fields[7]['show_error'] = false; return true; }
                if (fields[7].value.length) {
                    fields[7]['show_error'] = false;
                    return true;
                } else {
                    fields[7]['show_error'] = true;
                    fields[7]['error_text'] = 'Invalid State';
                    return false;
                }
            }
        }, {
            "index": 8,
            "group": "address",
            "type": "text",
            "label": "Zip Code",
            "value": "",
            "placeholder": "Optional (eg. 90210)",
            "name": "user[zipcode]",
            "validation_function": () => {
                const zipformat = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
                if (fields[8].value.length == 0) return true;
                if (fields[8].value.match(zipformat)) {
                    fields[8]['show_error'] = false;
                    return true;
                } else {
                    fields[8]['show_error'] = true;
                    fields[8]['error_text'] = 'Invalid zipcode';
                    return false;
                }
            }
        }, {
            "index": 9,
            "group": "contact",
            "type": "text",
            "label": "Home Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "user[home_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                if (fields[3].value === 'Vendor' && fields[9].value.length === 0) {
                    fields[9]['show_error'] = false;
                    return true;
                }
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[9].value.match(phoneformat)) {
                    fields[9]['show_error'] = false;
                    return true;
                } else {
                    fields[9]['show_error'] = true;
                    fields[9]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 10,
            "group": "contact",
            "type": "text",
            "label": "Cell Phone",
            "value": "",
            "placeholder": "eg. 000-000-0000",
            "name": "user[mobile_phone]",
            'change_function': (evt) => {
                var x = evt.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                evt.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            "validation_function": () => {
                if (fields[3].value === 'Vendor' && fields[10].value.length === 0) {
                    fields[10]['show_error'] = false;
                    return true;
                }
                const phoneformat = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                if (fields[10].value.match(phoneformat)) {
                    fields[10]['show_error'] = false;
                    return true;
                } else {
                    fields[10]['show_error'] = true;
                    fields[10]['error_text'] = 'Invalid phone number';
                    return false;
                }
            }
        }, {
            "index": 11,
            "group": "contact",
            "type": "select",
            "label": "Carrier",
            "value": "Other",
            "select_options": ["Verizon", "ATT", "T-Mobile", "Sprint", "Cricket", "MetroPCS", "MintMobile", "BoostMobile", "Other"],
            "name": "user[carrier]",
            "hidden": true,
            "validation_function": () => { return true; }
        }, {
            "index": 12,
            "group": "password",
            "type": "password",
            "label": "New Password",
            "value": "",
            "name": "user[password]",
            "validation_function": () => {
                if (!isPasswordRequire(fields[3].value)) {
                    fields[12]['show_error'] = false;
                    return true;
                }
                if (fields[12].value.length) {
                    const lowerCaseLetters = /[a-z]/g;
                    const upperCaseLetters = /[A-Z]/g;
                    const numbers = /[0-9]/g;
                    if (fields[12].value.length >= 6 && fields[12].value.match(lowerCaseLetters) && fields[12].value.match(upperCaseLetters) && fields[12].value.match(numbers)) {
                        fields[12]['show_error'] = false;
                        return true;
                    } else {
                        fields[12]['show_error'] = true;
                        fields[12]['error_text'] = 'Password is weak';
                        return false;
                    }
                } else {
                    fields[12]['show_error'] = true;
                    fields[12]['error_text'] = 'Password is required';
                    return false;
                }
            }
        }, {
            "index": 13,
            "group": "password",
            "type": "password",
            "label": "New Password Confirmation",
            "value": "",
            "name": "user[password]",
            "validation_function": () => {
                if (!isPasswordRequire(fields[3].value)) {
                    fields[13]['show_error'] = false;
                    return true;
                }
                if (fields[13].value.length) {
                    fields[13]['show_error'] = false;
                    return true;
                } else {
                    fields[13]['show_error'] = true;
                    fields[13]['error_text'] = 'Confirm Password is required';
                    return false;
                }
            }
        }, {
            "index": 14,
            "group": "contractor",
            "type": "toggle",
            "label": "Has Experience?",
            "value": true,
            "name": "user[has_experience]",
            "validation_function": () => { return true; }
        }, {
            "index": 15,
            "group": "contractor",
            "type": "text",
            "label": "Years of Experience",
            "value": "1",
            "placeholder": "eg: 2",
            "name": "user[years_experience]",
            "validation_function": () => {
                if (parseInt(fields[15].value) >= 0) {
                    fields[15]['show_error'] = false;
                    return true;
                } else {
                    fields[15]['show_error'] = true;
                    fields[15]['error_text'] = 'Year of Experience is required';
                    return false;
                }
            }
        }, {
            "index": 16,
            "group": "contractor",
            "type": "select",
            "label": "Time Availability",
            "value": "Part-Time",
            "select_options": ["Full-Time", "Part-Time"],
            "name": "user[time_availability]",
            "validation_function": () => { return true; }
        }, {
            "index": 17,
            "group": "contractor",
            "type": "toggle",
            "label": "Authorized to Work?",
            "value": true,
            "name": "user[authorized]",
            "validation_function": () => { return true; }
        }, {
            "index": 18,
            "group": "contractor",
            "type": "toggle",
            "label": "Insured?",
            "value": false,
            "name": "user[insured]",
            "validation_function": () => { return true; }
        }, {
            "index": 19,
            "group": "contractor",
            "type": "toggle",
            "label": "English Fluency?",
            "value": true,
            "name": "user[english_fluency]",
            "validation_function": () => { return true; }
        }, {
            "index": 20,
            "group": "contractor",
            "type": "toggle",
            "label": "Has a Truck?",
            "value": false,
            "name": "user[has_truck]",
            "validation_function": () => { return true; }
        }, {
            "index": 21,
            "group": "contractor",
            "type": "toggle",
            "label": "Internet Access?",
            "value": true,
            "name": "user[internet_access]",
            "validation_function": () => { return true; }
        }, {
            "index": 22,
            "group": "contractor",
            "type": "toggle",
            "label": "Smart Phone?",
            "value": true,
            "name": "user[smart_phone]",
            "validation_function": () => { return true; }
        }, {
            "index": 23,
            "group": "contractor2",
            "type": "textarea",
            "label": "Lawn Care Equipment",
            "value": "",
            "name": "user[lawn_equipment]",
            "validation_function": () => { return true; },
            'hidden': true
        }, {
            "index": 24,
            "group": "contractor2",
            "type": "textarea",
            "label": "How did you hear about us?",
            "value": "",
            "name": "user[hear_about_us]",
            "validation_function": () => { return true; }
        }, {
            "index": 25,
            "group": "comments",
            "type": "textarea",
            "label": "Additional Comments",
            "value": "",
            "name": "user[additional_comments]",
            "maxlength": 1000,
            "validation_function": () => { return true; }
        }, {
            "index": 26,
            "group": "comments",
            "type": "textarea",
            "label": "Internal Comments",
            "value": "",
            "name": "user[internal_comments]",
            "maxlength": 1000,
            "validation_function": () => { return true; }
        }, {
            "index": 27,
            "group": "basic1",
            "type": "text",
            "label": "Job Title",
            "value": "",
            "placeholder": "",
            "name": "user[job_title]",
            "maxlength": 100,
            "validation_function": () => { return true; }
        }, {
            "index": 28,
            "group": "basic1",
            "type": "text",
            "label": "Business Name",
            "value": "",
            "placeholder": "",
            "name": "user[business_name]",
            "maxlength": 100,
            "validation_function": () => { return true; }
        },
        {
            "index": 29,
            "group": "basic1",
            "type": "text",
            "label": "Title",
            "value": "",
            "placeholder": "",
            "name": "user[title]",
            "maxlength": 100,
            "validation_function": () => { return true; }
        }
    ];

    onMount(async () => {
        const params = new URLSearchParams($querystring);
        console.log('user_type', params.get("user_type"));
        if (params.has("user_type")) {
            let user_type = params.get("user_type");
            if (user_type === "owner") {
                user_type = 'Manager';
            } else if (user_type === 'admins') {
                user_type = 'Admin';
            } else if (user_type === 'managers') {
                user_type = 'Manager';
            } else if (user_type === 'clients') {
                user_type = 'Client';
            } else if (user_type === 'all_crew') {
                user_type = 'Contractor';
            } else if (user_type === 'contractors') {
                user_type = 'Contractor';
            } else if (user_type === 'employees') {
                user_type = 'Employee';
            } else if (user_type === 'vendors') {
                user_type = 'Vendor';
            } else if (user_type === 'applicants') {
                user_type = 'Applicant';
            } else {
                user_type = 'Employee';
            }
            console.log('User Type', user_type);
            default_user_type = user_type;
            fields[3].value = user_type;
            fields[3].change_function({target: { value: user_type }});
        }
    });

    const comparePassword = (password) => {
        const lowerCaseLetters = /[a-z]/g;
        const upperCaseLetters = /[A-Z]/g;
        const numbers = /[0-9]/g;
        if (fields[12].value.length >= 6 && fields[12].value.match(lowerCaseLetters) && fields[12].value.match(upperCaseLetters) && fields[12].value.match(numbers)) {
            fields[12]['show_error'] = false;
        } else {
            fields[12]['show_error'] = true;
            fields[12]['error_text'] = 'Password is weak';
            return;
        }
        const is_matching = fields[12].value === password && fields[13].value === password;
        if (!is_matching) {
            fields[12]['show_error'] = true;
            fields[12]['error_text'] = 'Password is not matching';
            fields[13]['show_error'] = true;
            fields[13]['error_text'] = 'Password is not matching';
        } else {
            fields[12]['show_error'] = false;
            fields[13]['show_error'] = false;
        }
        return is_matching;
    }

    const isPasswordRequire = (role) => {
        if (role === undefined) return false;
        role = role.toLowerCase();
        if (myself.plan_type === 'prime' || myself.plan_type === 'free') {
            if (role !== 'applicant' && role !== 'vendor') return true;
        } else {
            if (role !== 'applicant' && role !== 'vendor' && role !== 'contractor' && role !== 'employee' && role !== 'client' && role !== 'lead') return true;
        }
        return false;
    }

    const validateForm = () => {
        let is_valid = true;
        fields.forEach(field => {
            if (!field.validation_function()) { is_valid = false; }
        });
        if (fields[12].value !== fields[13].value) { is_valid = false; }
        return is_valid;
    }

    const create_user = async () => {
        is_busy = true;
        if (validateForm()) {
            let email = fields[2].value;
            let password = fields[12].value;
            if (fields[3].value === 'Vendor' || fields[3].value === 'Applicant') {
                if (email.length === 0) {
                    email = `${Date.now()}${myself.id}@houseofyards.tmp`;
                }
                password = Math.random().toString(36).slice(-12);
            }
            const payload = {
                first_name: fields[0].value,
                last_name: fields[1].value,
                business_name: fields[28].value,
                title: fields[29].value,
                job_title: fields[27].value,
                email: email.toLowerCase(),
                role: fields[3].value.toLowerCase(),
                profile_type: '',
                business_structure: fields[4].value,
                street: fields[5].value,
                city: fields[6].value,
                state: fields[7].value,
                zipcode: fields[8].value,
                home_phone: fields[9].value,
                mobile_phone: fields[10].value,
                carrier: fields[11].value,
                password: password,
                has_experience: fields[14].value,
                years_experience: fields[15].value,
                time_availability: fields[16].value,
                authorized: fields[17].value,
                insured: fields[18].value,
                english_fluency: fields[19].value,
                has_truck: fields[20].value,
                internet_access: fields[21].value,
                smart_phone: fields[22].value,
                lawn_equipment: fields[23].value,
                hear_about_us: fields[24].value,
                additional_comments: fields[25].value,
                internal_comments: fields[26].value,
                emails: fields[3].value.toLowerCase() === 'client' ? emails : []
            };
            const { auth_type, auth_token, domain_code } = getToken();
            const res = await doFetch(
                api_host + "/api/create/user",
                'POST',
                payload,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 2000);
                init_data('users');
                if (default_user_type === 'Vendor') {
                    push('#/Accountingexpenses');
                } else {
                    push('#/Users?filter=all');
                }
            }
            else { toast_message(false, res.msg || 'Bad request', 2000); }
        } else {
            toast_message(false, 'Missing or invalid info', 2000);
        }
        is_busy = false;
    }
</script>

<Header title={content_title} is_busy={is_busy} />

<div class="contentholder">
    <div class="section pricingsettings">
        <div class="sectionsubtitle">Basic</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e)=>e.group === "basic1") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:hidden={nf.hidden}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>

        <div class="sectioninfo pricingsettings">
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e)=>e.group === "basic2") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
        </div>
        {#if (fields[3].value.toLowerCase() == 'client')}
        <div class="sectioninfo pricingsettings">
            <div class="ff" style="padding: 5px; padding-bottom: 30px;">
                <div style="font-weight: 600; padding-bottom: 10px;">Secondary Emails</div>
                <div style="display: flex; flex-direction: column; width: 300px;">
                    {#each emails as email, index }
                    <div style="display: flex; flex-direction: row; justify-content: space-between; padding-bottom: 5px;">
                        <span>{email}</span>
                        <button class="btn-icon" on:click={() => remove_email(index)}><i class="fa fa-trash"></i></button>
                    </div>
                    {/each}
                </div>
                {#if adding_email}
                <div style="display: flex;">
                    <input
                        type="email"
                        bind:value={temp_email}
                        on:keyup={event => {
                            if (event.key === 'Enter') {
                                add_email();
                            }
                        }}
                    />
                    <button style="margin-left: 10px;" class="save" on:click={add_email}>Add</button>
                    <button style="margin-left: 10px;" on:click={() => adding_email=false}>Cancel</button>
                </div>
                {:else}
                <div>
                    <button class="save" on:click={() => adding_email=true}><i class="fa-plus" style="font-style: normal;"></i> Add</button>
                </div>
                {/if}
            </div>
        </div>
        {/if}

        <div class="row twolinedata">
            <div class="column leftdata">
                <div class="sectionsubtitle">Address</div>
                <div class="sectioninfo pricingsettings">
                    <div class="ff formrow pricingsettings">
                        {#each fields.filter((e)=>e.group === "address") as nf}
                        <IFTAInput 
                            type={(nf.type !== undefined) ? nf.type : ""} 
                            label={(nf.label !== undefined) ? nf.label : ""} 
                            placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                            helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                            select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                            readonly={nf.readonly}
                            disabled={nf.disabled}
                            name={nf.name}
                            show_error={nf.show_error}
                            error_text={nf.error_text}
                            bind:value={nf.value}
                            bind:change_function={nf.change_function}
                            bind:validation_function={nf.validation_function}
                            bind:extFuncs={nf.ext_funcs}
                        />
                        {/each}
                    </div>    
                </div>

                <div class="sectionsubtitle">Contact</div>
                <div class="sectioninfo pricingsettings">
                    <div class="ff formrow pricingsettings">
                        {#each fields.filter((e)=>e.group === "contact") as nf}
                        <IFTAInput 
                            type={(nf.type !== undefined) ? nf.type : ""} 
                            label={(nf.label !== undefined) ? nf.label : ""} 
                            placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                            helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                            select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                            readonly={nf.readonly}
                            disabled={nf.disabled}
                            name={nf.name}
                            show_error={nf.show_error}
                            error_text={nf.error_text}
                            bind:value={nf.value}
                            bind:hidden={nf.hidden}
                            bind:change_function={nf.change_function}
                            bind:validation_function={nf.validation_function}
                            bind:extFuncs={nf.ext_funcs}
                        />
                        {/each}
                    </div>    
                </div>
            </div>
        </div>

        {#if isPasswordRequire(fields[3].value)}
        <div class="sectionsubtitle">Create Password</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff rowwrap pricingsettings">
                {#each fields.filter((e)=>e.group === "password") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    comparePassword={comparePassword}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>
            <div style="padding-left: 15px;color: #2f2f2f;">
                Password must contain:
                <ul>
                    <li>Minimum 6 characters</li>
                    <li>A lowercase letter</li>
                    <li>A capital letter</li>
                    <li>A number</li>
                </ul>
            </div>
        </div>
        {/if}

        {#if fields[3].value.toLowerCase() == 'contractor' || fields[3].value.toLowerCase() == 'employee'}
            <div class="sectionsubtitle">Crew Information</div>
            {#if fields[3].value.toLowerCase() == 'contractor'}
            <div class="sectioninfo pricingsettings">
                <div class="ff rowwrap pricingsettings">
                    {#each fields.filter((e) => e.group === "contractor") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/each}
                </div>    
            </div>
            {/if}
            <div class="sectioninfo pricingsettings">
                <div class="ff formrow pricingsettings">
                    {#each fields.filter((e) => e.group === "contractor2") as nf}
                    <IFTAInput 
                        type={(nf.type !== undefined) ? nf.type : ""} 
                        label={(nf.label !== undefined) ? nf.label : ""} 
                        placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                        helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                        select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                        readonly={nf.readonly}
                        disabled={nf.disabled}
                        name={nf.name}
                        show_error={nf.show_error}
                        error_text={nf.error_text}
                        bind:hidden={nf.hidden}
                        bind:value={nf.value}
                        bind:change_function={nf.change_function}
                        bind:validation_function={nf.validation_function}
                        bind:extFuncs={nf.ext_funcs}
                    />
                    {/each}
                </div>    
            </div>
        {/if}

        <div class="sectionsubtitle">Additional Information</div>
        <div class="sectioninfo pricingsettings">
            <div class="ff formrow pricingsettings">
                {#each fields.filter((e) => e.group === "comments") as nf}
                <IFTAInput 
                    type={(nf.type !== undefined) ? nf.type : ""} 
                    label={(nf.label !== undefined) ? nf.label : ""} 
                    placeholder={(nf.placeholder !== undefined) ? nf.placeholder : ""} 
                    helper_text={(nf.helper_text !== undefined) ? nf.helper_text : ""} 
                    select_options={(nf.select_options !== undefined) ? nf.select_options : ""} 
                    readonly={nf.readonly}
                    disabled={nf.disabled}
                    name={nf.name}
                    show_error={nf.show_error}
                    error_text={nf.error_text}
                    maxlength={nf.maxlength}
                    bind:hidden={nf.hidden}
                    bind:value={nf.value}
                    bind:change_function={nf.change_function}
                    bind:validation_function={nf.validation_function}
                    bind:extFuncs={nf.ext_funcs}
                />
                {/each}
            </div>    
        </div>
    </div>

    <div class="section updatebutton">
        <button class="save" on:click={create_user} disabled={is_busy}>Create User</button>&nbsp;&nbsp;
        <button class="save" on:click={() => { push('#/Users?filter=all') }} disabled={is_busy} style='background-color: #cd4646;'>Cancel</button>
    </div>
</div>
        

<style>
    .ff {
        padding: 10px;
        padding-bottom: 0px;
        width: 100%;
    }
    :global(.ff .group) {
        margin-left: 5px;
        margin-right: 5px;
    }
    .formrow {
        padding: 0px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .sectioninfo {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .column{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .row{
        padding: 0px;
        margin: 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    .contentholder {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(12, 1fr);
        grid-template-rows: auto;
        grid-template-areas: "sq sq sq sq sq sq sq sq sq sq sq sq"
                             "ps ps ps ps ps ps ps ps ps ps ps ps"
                             "ub ub ub ub ub ub ub ub ub ub ub ub";
        gap: 20px;
    }
    .pricingsettings {
        grid-area: ps;
    }
    .updatebutton {
        grid-area: ub;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        background-color: #357a38;
        color: white;
        padding-left: 20px;
        padding-right: 20px;
    }
    :global(.rowwrap) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    :global(.rowwrap .group) {
        min-width: 300px;
        max-width: 300px;
    }
    :global(.settingsqlbutton .filterbuttonholder) {
        width: 600px !important;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .ff {
            padding: 0px;
            width: 100%;
        }
        .formrow {
            width: 100%;
            padding: 0px;
            display: flex;
            flex-direction: column;
        }
        .sectioninfo {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        .column{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .row{
            padding: 0px;
            margin: 0px;
            display: flex;
            flex-direction: column;
            width: 100%;
        }
        .contentholder {
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            grid-template-rows: auto;
            grid-template-areas: "sq"
                                 "ps"
                                 "ub";
            gap: 20px;

        }
        .pricingsettings {
            grid-area: ps;
        }
        .updatebutton {
            grid-area: ub;
            display: flex;
            flex-direction: column;
            padding: 0px;
        }
        .updatebutton .save {
            width: 100%;
            background-color: #357a38;
            color: white;
        }
        :global(.rowwrap) {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0px;
            margin: 0px;
        }
        :global(.rowwrap .group) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }
        :global(.settingsqlbutton .filterbuttonholder) {
            width: 100% !important;
        }
    }
</style>